module.exports = __webpack_public_path__ + "img/img_app_download.cac5ca78.svg";